import type { Booking } from '../../lib/types'
import { formatPrice, timeAgo } from '../../lib/format'
import { RouteDisplay } from '../ui/RouteDisplay'

export function BookingRow({ booking, showStatus = true, onClick }: { booking: Booking; showStatus?: boolean; onClick?: () => void }) {
  const segments = booking.segments || []

  return (
    <tr className="cursor-pointer" onClick={onClick}>
      <td className="font-medium text-stone-900 dark:text-stone-100">{booking.user_name}</td>
      <td className="text-stone-600 dark:text-stone-400 font-medium">{booking.airline_code}</td>
      <td>
        {segments.length > 0 ? (
          <RouteDisplay
            segments={segments.map(s => ({ origin: s.origin, destination: s.destination }))}
            tripType="one_way"
          />
        ) : (
          <span className="text-stone-400">N/A</span>
        )}
        {segments.length > 1 && <span className="text-stone-400 text-xs ml-1">({segments.length})</span>}
      </td>
      <td className="font-mono text-xs text-stone-500">{booking.pnr}</td>
      <td className="text-stone-700 dark:text-stone-300 font-data tabular-nums">
        {formatPrice(booking.is_award_booking ? booking.points_used : booking.total_price_paid, booking.is_award_booking)}
      </td>
      {showStatus && (
        <td>
          <span className={`inline-flex items-center gap-1.5 text-xs ${booking.is_active ? 'text-emerald-600' : 'text-stone-400'}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${booking.is_active ? 'bg-emerald-500' : 'bg-stone-300'}`} />
            {booking.is_active ? 'Active' : 'Inactive'}
          </span>
        </td>
      )}
      <td className="text-stone-500 text-xs">{timeAgo(booking.last_checked_at)}</td>
    </tr>
  )
}
